export default class DtoCmsModelTideGauge {
    constructor(obj) {
        this.modelId = obj.modelId
        this.tideGaugeId = obj.tideGaugeId
        this.stationCode = obj.stationCode
        this.order = obj.order
    }
}
